/**
 * @author Ariel
 * @date 2021-06-02
 * @desc 列表页配置
 */
import React from 'react'
import {component_tool} from '../../../../../tool';
import ApplyPlanCol from "../applyPlanCol";

let { WizModal, WizDataTable, WizButton } = component_tool

let componentName = 'applyPlan'

const columns = (applyId,self) => [
  {
    name: 'id',
    formItem: {type: 'hidden'}
  },
  {
    name: 'applyId',
    formItem: {type: 'hidden', initialValue: applyId}
  },
  {
    title: '计划安排名称',
    name: 'name',
    tableItem: {},
    searchItem: {},
  },
  {
    title: '安排类型',
    name: 'type',
    tableItem: {
      render: (text, record) => {
        return "班级"
      }
    },
  },
  {
    title: '班级名称',
    name: 'className',
    tableItem: {
      render: (text, record) => (
        <WizDataTable.Oper>
          <WizButton tooltip={text}
                     onClick={() => {
                       self.jumpPage && self.jumpPage(
                         'push',
                         '/workflow/apply/applyPlanClass/classResult',
                         {id: record.entityId }
                       )
                     }}>
            {text}
          </WizButton>
        </WizDataTable.Oper>
      )
    },
  },
  {
    title: '计划安排时间',
    name: 'planTime',
    tableItem: {
      render: (text, record) => {
        let {startTime, endTime} = record
        let value = startTime + ' ~ ' + endTime
        return <div>{value}</div>
      }
    },
  },
  {
    title: '地址',
    name: 'address',
    tableItem: {},
  },
  {
    title: '报名时间限制',
    name: 'applyTimeStr',
    tableItem: {},
  },
  {
    title: '限制人数',
    name: 'limitCount',
    tableItem: {
      render: (text, record) => {
        if (text < 0) {
          text = '不限制'
        }
        return text
      }
    },
  },
  {
    title: '报名通过人数',
    name: 'passNumber',
    tableItem: {},
  },
  {
    title: '已录成绩人数',
    name: 'hasResultCount',
    tableItem: {},
  },
  {
    title: '培训通过人数',
    name: 'passCount',
    tableItem: {},
  },
  {
    title: '请假人数',
    name: 'leaveCount',
    tableItem: {},
  },
  {
    title: '安排状态',
    name: 'state',
    searchItem: {
      type: 'select'
    },
    tableItem: {},
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'},
    ],
  },
]

const templateConfig = (data) => {
  let {applyId, _addPlanBtn, self} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(applyId,self),
        btnAccessCheck: false,
        searchBarProps: {
          collapse: false,
          buttonSort: ['add', 'syncUpdatePlan', 'importStudentGrades', 'exportStudentGrades'],
          buttons: [
            {
              key: 'add',
              name: "WizButton",
              params: {icon: 'plus', children: '新增计划安排', type: 'primary', key: '_btn'},
              onClick: e => _addPlanBtn && _addPlanBtn(e)
            },
            {
              key: 'syncUpdatePlan',
              custom: true,
              params: {icon: 'sync', children: '同步班级数据', type: 'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'syncUpdatePlan',
                  apiParams: {id: applyId}
                }
              }
            },
            {
              key: 'importStudentGrades',
              custom: true,
              params: {icon: 'import', children: '导入学员成绩', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/workflow/apply/applyPlanClass/importStudentGrades',
                  record: {applyId: applyId}
                }
              }
            },
            {
              key: 'exportStudentGrades',
              custom: true,
              params: {icon: 'export', children: '导出学员成绩', type: 'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'exportStudentGrades'
                },
                formatParams: (rows, record, filter) => {
                  return { ...filter };
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'enableOrDisable', 'delete'],
        rowOperateView: [
          {
            key: 'update',
            custom: true,
            params: {children: '编辑'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '编辑计划安排',
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <ApplyPlanCol applyId={applyId} changeModal={e.changeModal} type={1} record={e.record}/>
                    </>
                  },
                  width: 750
                }
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "有效"},
            textFormat: {
              recordKey: 'state',
              dirt: {'1': '禁用', '0': '启用',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                }该计划安排吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      id: record['id'],
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "delete",
            custom: true,
            params: {children: "删除"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "delete",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = '删除后数据不可恢复，您确定要删除选中的安排吗？'
                let ids = [];
                if (record) {
                  ids.push(record.id)
                }
                if (record && record.applyNumber > 0) {
                  wizNotice.error("该计划安排已有报名人员，不能删除")
                } else {
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids
                      })
                    },
                    onCancel() {
                    }
                  });
                }
                return null
              }
            },
          },
        ],
        commonOperate: {
          add: true,
          delete: true,
          update: true,
          enable: true
        }
      }
    }
  }
};

const apis = (applyId = []) => {
  return {
    list: {
      path: `${componentName}/planPageList`,
      payload: {
        key: `${componentName}@planPageList`,
        apiParams: {applyId: applyId}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    enable: {
      path: `${componentName}/enablePlan`,
      payload: {
        key: `${componentName}@enablePlan`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/deletePlan`,
      payload: {
        key: `${componentName}@deletePlan`,
        apiParams: {}
      }
    },
    syncUpdatePlan: {
      path: `apply/syncUpdatePlan`,
      payload: {
        key: `apply@syncUpdatePlan`,
        apiParams: {id: applyId}
      }
    },
    exportStudentGrades: {
      path: `${componentName}/exportStudentGrades`,
      payload: {
        key: `${componentName}@exportStudentGrades`,
        apiParams: {applyId: applyId}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  let {applyId} = args
  return {
    apis: apis(applyId),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
